import { Injectable } from '@angular/core';
import { featureTogglingConfig } from '@app/shared/constants/feature.config';
import { Observable } from 'rxjs';
import { HttpClientService } from '../../core/http-client/http-client.service';
import { services } from '../../core/settings';
import { OrderListModel } from '../../shared/models/admin/Orders/order-list';

@Injectable({
    providedIn: 'root'
})
export class ManageOrderService {
    private static readonly endpoint = featureTogglingConfig.orders.pages['create-business-order'].concierge ? 'Order' : 'OrderExpress';
    private static readonly endpointWorkorder = featureTogglingConfig.operations.pages['manage-workorders'].concierge ? 'Workorder' : 'WorkorderExpress';

    constructor(private http: HttpClientService) { }

    listByPagination(body: any): Observable<OrderListModel[]> {
        return this.http.post<OrderListModel[]>(body, `${ManageOrderService.endpoint}/GetAllPagginated`, undefined, services.orderService);
    }

    delete(id: number) {
        return this.http.delete<boolean>(`${ManageOrderService.endpoint}/Delete/${id}`, undefined, services.orderService);
    }

    listWorkordersByPagination(body: any): Observable<any[]> {
        return this.http.post<any[]>(body, `${ManageOrderService.endpointWorkorder}/WorkorderForDispatch`, undefined, services.orderService);
    }

    exportToExcel(body: object) {
        return this.http.postWithOptions<Blob>(body,`${ManageOrderService.endpoint}/ExportToExcel`,undefined, { responseType: 'blob' },  services.orderService);
    }
}
